import { ArrowRight } from "lucide-react";

export default function CTA() {
  return (
    <div className="px-5 py-5 mb-5 mt-5">

      <div className="w-full mx-auto bg-orange-500 text-white rounded-md py-4 px-6 flex items-center justify-between">

        {/* LEFT TEXT */}
        <div>
          <h2 className="text-base font-semibold">
            Start Delivering with Jopo Today!
          </h2>

          <p className="text-xs text-orange-100">
            Fast, secure and reliable delivery service you can trust.
          </p>
        </div>

        {/* RIGHT BUTTON */}
        <button className="flex items-center gap-2 bg-green-900 hover:bg-green-800 text-white px-6 py-2 rounded-full text-sm transition">

          Request a delivery

          <ArrowRight size={16} className="mt-[5px]"/>

        </button>

      </div>
    </div>
  );
}